var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"12.7189","cy":"13.5177","r":"12.7189","transform":"rotate(-90 12.7189 13.5177)"}));
}

Circle.defaultProps = {"viewBox":"0 0 26 27","fill":"none"};

module.exports = Circle;

Circle.default = Circle;
